module.exports = __webpack_public_path__ + "img/服务案例05.16ad87f4.png";